export const URL = {
    currentENV: "STAGING",
    //Temporary copied from attributes of staging
    LOCAL: {
        login:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/login',
        getApiKey:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/appsynckey',
        graphQl:
            'https://qxpypvxeqzbsdeh6iiplggyzwe.appsync-api.ap-northeast-1.amazonaws.com/graphql',
        graphQlAdmin:
            'https://gi5yddqt55ed7kqev5xmxepaxy.appsync-api.ap-northeast-1.amazonaws.com/graphql',
        masterData:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/masterdata',
        downloadAgpReport: 
            "https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/download-agp-report",
        api: "https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging",
        },
    DEVELOPMENT: {
        login:
            'https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus/login',
        uploadProfilePic:
            'https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus/profilepicupload',
        masterData:
            'https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus/masterdata',
        getApiKey:
            'https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus/appsynckey',
        graphQl:
            'https://bzh3lnhdwndtdi4blmf6eycbxe.appsync-api.us-east-1.amazonaws.com/graphql',
        graphQlAdmin:
            'https://qjklcqap3zew5gokivaxvlynsy.appsync-api.us-east-1.amazonaws.com/graphql',
        profileUrl: 'https://lifeplusweb.s3.amazonaws.com/profilePictures/',
        downloadAgpReport: 
                "https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus/download-agp-report",
        api: "https://7k7mletvt5.execute-api.us-east-1.amazonaws.com/lifeplus",
    },
    STAGING: {
        login:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/login',
        uploadProfilePic:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/profilepicupload',
        getApiKey:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/appsynckey',
        masterData:
            'https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/masterdata',
        graphQl:
            'https://qxpypvxeqzbsdeh6iiplggyzwe.appsync-api.ap-northeast-1.amazonaws.com/graphql',
        graphQlAdmin:
            'https://gi5yddqt55ed7kqev5xmxepaxy.appsync-api.ap-northeast-1.amazonaws.com/graphql',
        profileUrl: 'https://staging-admin.lifeplus.ai/profilePictures/',
        downloadAgpReport: 
            "https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging/download-agp-report",
        api: "https://nw9du03kjk.execute-api.ap-northeast-1.amazonaws.com/Staging",
    },
    PRODUCTION: {
        api: "https://admin.lifeplus.ai",
        login: "https://api.lifeplus.ai/login",
        graphQlAdmin: "https://api-admin.lifeplus.ai",
        masterData: "https://api.lifeplus.ai/masterdata",
        getApiKey: "https://api.lifeplus.ai/appsynckey",
        downloadAgpReport: "https://api.lifeplus.ai/download-agp-report"
      },
};